export default __webpack_public_path__ + "static/media/procviz.1e882258.png";